import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Award, FileText, Calendar, User } from 'lucide-react';

const QuickActionsWidget = ({ rollNumber }) => {
  const navigate = useNavigate();

  const actions = [
    { icon: Award, label: 'Add Achievement', path: '/student/achievements', color: 'blue' },
    { icon: Calendar, label: 'Apply Leave', path: '/student/apply-leave', color: 'green' },
    { icon: FileText, label: 'Psychometric Test', path: '/student/psychometric-test', color: 'purple' },
    { icon: User, label: 'Edit Profile', path: '/student/profile', color: 'orange' },
    { icon: FileText, label: 'End Semester Report', path: '/student/end-semester-report', color: 'slate' },
  ];

  return (
    <div className="grid grid-cols-2 gap-3">
      {actions.map((action, idx) => (
        <button
          key={idx}
          onClick={() => navigate(action.path)}
          className={`flex flex-col items-center space-y-2 p-4 bg-${action.color}-50 border border-${action.color}-200 rounded-lg hover:bg-${action.color}-100`}
        >
          <action.icon className={`w-6 h-6 text-${action.color}-600`} />
          <span className="text-sm font-medium text-gray-700">{action.label}</span>
        </button>
      ))}
    </div>
  );
};

export default QuickActionsWidget;
